import qs from "qs";
import axios from "axios";
import Jsona from "jsona";

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, { encode: false });
    },
  };

  return axios.get(`${url}/stock-movements`, options).then((response) => {
    return {
      list: jsona.deserialize(response.data),
      meta: response.data.meta,
    };
  });
}

function get(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .get(
      `${url}/stock-movements/${id}?include=sourceWarehouse,destinationWarehouse,items,items.storable,organization,allowedLocations,destinationWarehouse,triggerObject`,
      options
    )
    .then((response) => {
      let stockMovement = jsona.deserialize(response.data);
      delete stockMovement.links;
      return stockMovement;
    });
}

function add(stockMovement) {
  const payload = jsona.serialize({
    stuff: stockMovement,
    includeNames: null,
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .post(`${url}/stock-movements`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function update(stockMovement) {
  const payload = jsona.serialize({
    stuff: stockMovement,
    includeNames: [],
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .patch(`${url}/stock-movements/${stockMovement.id}`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios.delete(`${url}/stock-movements/${id}`, options);
}

function validate(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .get(
      `${url}/stock-movements/${id}/validate?include=sourceWarehouse,destinationWarehouse,items,items.storable,organization,allowedLocations,destinationWarehouse,triggerObject`,
      options
    )
    .then((response) => {
      let stockMovement = jsona.deserialize(response.data);
      delete stockMovement.links;
      return stockMovement;
    });
}

function cancel(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .get(
      `${url}/stock-movements/${id}/cancel?include=sourceWarehouse,destinationWarehouse,items,items.storable,organization,allowedLocations,destinationWarehouse,triggerObject`,
      options
    )
    .then((response) => {
      let stockMovement = jsona.deserialize(response.data);
      delete stockMovement.links;
      return stockMovement;
    });
}

export default {
  list,
  get,
  add,
  update,
  destroy,
  validate,
  cancel,
};
